export default __webpack_public_path__ + "static/media/badge-5.61fd7b8f.png";